import React from 'react';
import PropTypes from 'prop-types';
import request from '../../utils/agent';
import Loader from 'components/Loader';
import { Formik, Field, FieldArray, Form } from 'formik';
import * as Yup from 'yup';


export default class ResellerProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userD: { },
            companyD: { },
            cData: { },
            operationRad: { },
            userLoaded: false,
            compLoaded: false,
            cDataLoaded: false,
            updateFlag: false,
            editingProfile: false,
            isError: false,
            uploadingProfile: false,
            uploadingCertificate: false,
            host:"",
            geo: null,
            lat: null,
            long: null,
            address_status: "",
            address: "",
            city: "",
            postal: "",
            country: "",
            state: "",
            touched: {
                address: false,
                city: false,
                postal: false,
                country: false,
                state: false,
            }
        };
    }

    editProfile = () => {
        this.setState({editingProfile: !this.state.editingProfile});
    };


    componentDidMount() {
        this.getUserData();
        this.getCompanyData();
        this.getcData();
    }

    componentDidUpdate() {
        if(this.state.updateFlag === true) {
            this.getUserData();
            this.getCompanyData();
            this.getcData();
            this.setState({
                updateFlag: false,
                editingProfile: false,
            });
        };

        if(this.state.editingProfile === true) {
            this.addressListener();
        }
    }

    componentWillUnmount() {

    }

    addressListener = () => {
        const autocompleteFormField = document.getElementById(`addressAutocomplete.street`);

        const autocomplete = new google.maps.places.Autocomplete((autocompleteFormField), {
            types: [`address`]
        });

        google.maps.event.addListener(autocomplete, `place_changed`, () => {
            const place = autocomplete.getPlace();
            let ac = place.address_components;
            var address = {
                country: ac.filter(c => ~c.types.indexOf('country'))[0].short_name,
                street: place.name,
                city: ac.filter(c => ~c.types.indexOf('locality'))[0].long_name,
                state: ac.filter(c => ~c.types.indexOf('administrative_area_level_1'))[0].short_name,
                postal: ac.filter(c => ~c.types.indexOf('postal_code'))[0].short_name
            };

            //console.log(address); // This is our address selected component

            // I don't know how you would pass these to Formik.
            for(let key in address) {
                try {
                    document.getElementById(`addressAutocomplete.${key}`).value = address[key];
                    this.setState({
                        address: address.street,
                        city: address.city,
                        postal: address.postal,
                        country: address.country,
                        state: address.state,
                    })
                } catch(e) {
                    console.log(`Unable to set addressAutocomplete.${key}:${address[key]}`);
                }
            }

        });
    };

    handleAdrChange = (e) => {
        e.preventDefault();
        this.setState({
            address: e.target.value,
        })
    };
    handleCountryChange = (e) => {
        e.preventDefault();
        this.setState({
            country: e.target.value,
        })
    };
    handleCityChange = (e) => {
        e.preventDefault();
        this.setState({
            city: e.target.value,
        })
    };
    handleStateChange = (e) => {
        e.preventDefault();
        this.setState({
            state: e.target.value,
        })
    };
    handlePostalChange = (e) => {
        e.preventDefault();
        this.setState({
            postal: e.target.value,
        })
    };

    handleAdrBlur = (fieldName) => (e) => {
        this.setState({
            touched: {
                ...this.state.touched, [fieldName]: true
            },
        })
    };

    validateAdr(address, city, state, postal, country){
        return {
            address: address.length === 0,
            city: city.length === 0,
            state: state.length === 0,
            postal: postal.length === 0,
            country: country.length === 0,
        };
    };

    handleSubmitErr(e) {
        e.preventDefault();
        this.setState({
            touched: {
                address: true,
                city: true,
                postal: true,
                country: true,
                state: true,
            }
        })
    };


    getUserData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        userD: resp.body.user,
                        userLoaded: true
                    });
                    //console.log('us', resp.body.user);
                    resolve(resp.body);
                });

        });
    };

    getcData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/user')
                .then(resp => {
                    this.setState({
                        cData: resp.body.user.cdata,
                        cDataLoaded: true
                    });
                    resolve(resp.body);
                });
        });
    };

    getCompanyData = () => {
        return new Promise((resolve, reject) => {
            request.get('/api/company')
                .then(resp => {
                    this.setState({
                        companyD: resp.body.company,
                        compLoaded: true,
                        address: resp.body.company.address,
                        city: resp.body.company.city,
                        postal: resp.body.company.postal,
                        country: resp.body.company.country,
                        state: resp.body.company.state,
                    });
                    resolve(resp.body);
                });

        });
    };


    uploadProfileImage = () => {
        this.refs.onUploadUserFile.click();
        this.__FILETYPE__ = 'profile';
        this.setState({uploadingProfile: true});
    }

    uploadResellerCertificate = () => {
        this.refs.onUploadUserFile.click();
        this.__FILETYPE__ = 'certificate';

        this.setState({uploadingCertificate: true});
    }

    onUploadUserFile = async (evt) => {
        this.__FILE__ = evt.target.files;
        
        const formData = new FormData();
        // Save our new file name as `profile-ID.EXT`

        let epox = (new Date).getTime();
        if(this.__FILETYPE__ === 'profile' && this.state.companyD.logo_path !== undefined) {
            const splitted = this.state.companyD.logo_path.split('/');
            const uniP =  splitted[splitted.length-1].replace(/[^0-9]/g, '');
            //console.log('uniProfile', uniP);
            epox = uniP;
        }

        if(this.__FILETYPE__ === 'certificate' && this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null") {
            const splitted = this.state.companyD.reseller_certification_path.split('/');
            const uniC =  splitted[splitted.length-1].replace(/[^0-9]/g, '');
            //console.log('uniCert', uniC);
            epox = uniC;
        }

        //console.log('epox', epox);

        let fileName = `${this.__FILETYPE__}-${epox}.${this.__FILE__[0].name.split('.').pop()}`
        formData.append('file', this.__FILE__[0], fileName);
        let location = await request.post(`/api/user/upload/${this.__FILETYPE__}`)
            .send(formData)
            .then(resp => {
                //console.log(resp);
                return resp.body.Location;
            })
            .catch(err => {
                console.log(err);
                this.__FILE__ = null;
                this.__FILETYPE__ = null;
            });

        console.log('done uploading');
        let field = this.__FILETYPE__ === 'profile' ? 'logo_path' : 'reseller_certification_path';
        let payload = {
            [field]: location
        };
        this.updateCompany(payload);
    };

    updateCompany = (payload) => {
        request.put(`/api/company/${this.state.companyD.id}`)
            .send(payload)
            .then(resp => {
                this.setState({
                    companyD: resp.body.update_company,
                    uploadingProfile: false,
                    uploadingCertificate: false
                });
            })
            .catch(err => {
                console.log(err);
            });
    };

    handleVerifyAddress = async(address, city, state, postal, country) => {
        //evt.preventDefault();
        let geoloc = await request.post(`/api/company/address/coordinates`)
            .send ({"address": {"address": address, "country": country, "city": city, "state": state, "postal": postal}
            })
            .then(resp => {
                //console.log('response',resp.body.geospatial);
                return resp.body;
            })
            .catch(err => {
                console.log(err);
            });

       //console.log('geoloc', geoloc);
        if (geoloc !== undefined) {
            this.setState({
                geo: geoloc.geospatial,
                lat: geoloc.latitude,
                long: geoloc.longitude,
                address_status: "valid",
            })
        }

    };

    render() {

        const errors = this.validateAdr(this.state.address, this.state.city, this.state.state, this.state.state, this.state.country);
        //console.log('errors', errors);

        const isDisabled = Object.keys(errors).some(x => errors[x]);
        //console.log('isDisabled', isDisabled);

        //console.log('touched', this.state.touched);

        const shouldShowError = (fieldName) => {
            const hasErr = errors[fieldName];
            const shouldShow = this.state.touched[fieldName];
            return hasErr ? shouldShow : false;
        };



        //console.log('street address state', this.state.address);
        //console.log('city state', this.state.city);
        //console.log('postal state', this.state.postal);
        //console.log('country state', this.state.country);
        //console.log('state state', this.state.state);


        //console.log('user data', this.state.userD);
       //console.log('companyD', this.state.companyD);
       // console.log('geo', this.state.geo);
       // console.log('lat', this.state.lat);
       // console.log('long', this.state.long);
        //console.log('status', this.state.address_status);
        //console.log('flag', this.state.notValidated);

       // console.log('user cdata', this.state.cData);
      //  console.log('host', this.state.host);
        //console.log('user loaded', this.state.userLoaded);
        //console.log('company loaded', this.state.compLoaded);

        const countryOpts = [
            {id: 'US', display: 'USA'},
            {id: 'CA', display: 'Canada'},
        ];

        const caStateOpts = [
            { id: 'AL', display: 'Alberta'},
            { id: 'BC', display: 'British Columbia'},
            { id: 'MA', display: 'Manitoba'},
            { id: 'NB', display: 'New Brunswik'},
            { id: 'NL', display: 'Newfoundlend and Labrador'},
            { id: 'NS', display: 'Nova Scotia'},
            { id: 'ON', display: 'Ontario'},
            { id: 'PEI', display: 'Price Edward Island'},
            { id: 'QU', display: 'Quebeck'},
            { id: 'SA', display: 'Saskatchewan'},
        ];

        const usStateOpts = [
            { id: 'AL', display: 'Alabama'},
            { id: 'AK', display: 'Alaska'},
            { id: 'AZ', display: 'Arizona'},
            { id: 'AR', display: 'Arkansas'},
            { id: 'CA', display: 'California'},
            { id: 'CO', display: 'Colorado'},
            { id: 'CT', display: 'Connecticut'},
            { id: 'DC', display: 'District of Columbia'},
            { id: 'DE', display: 'Delaware'},
            { id: 'FL', display: 'Florida'},
            { id: 'GA', display: 'Georgia'},
            { id: 'HI', display: 'Hawaii'},
            { id: 'ID', display: 'Idaho'},
            { id: 'IA', display: 'Iowa'},
            { id: 'IL', display: 'Illinois'},
            { id: 'IN', display: 'Indiana'},
            { id: 'KS', display: 'Kansas'},
            { id: 'KY', display: 'Kentucky'},
            { id: 'LA', display: 'Louisiana'},
            { id: 'ME', display: 'Maine'},
            { id: 'MD', display: 'Maryland'},
            { id: 'MA', display: 'Massachusetts'},
            { id: 'MI', display: 'Michigan'},
            { id: 'MN', display: 'Minnesota'},
            { id: 'MS', display: 'Mississippi'},
            { id: 'MO', display: 'Missouri'},
            { id: 'MT', display: 'Montana'},
            { id: 'NE', display: 'Nebraska'},
            { id: 'NH', display: 'New Hampshire'},
            { id: 'NJ', display: 'New Jersey'},
            { id: 'NM', display: 'New Mexico'},
            { id: 'NV', display: 'Nevada'},
            { id: 'NY', display: 'New York'},
            { id: 'NC', display: 'North Carolina'},
            { id: 'ND', display: 'North Dakota'},
            { id: 'OH', display: 'Ohio'},
            { id: 'OK', display: 'Oklahoma'},
            { id: 'OR', display: 'Oregon'},
            { id: 'PA', display: 'Pennsylvania'},
            { id: 'RI', display: 'Rhode Island'},
            { id: 'SC', display: 'South Carolina'},
            { id: 'SD', display: 'South Dakota'},
            { id: 'TN', display: 'Tennessee'},
            { id: 'TX', display: 'Texas'},
            { id: 'UT', display: 'Utah'},
            { id: 'VT', display: 'Vermont'},
            { id: 'VA', display: 'Virginia'},
            { id: 'WA', display: 'Washington'},
            { id: 'WV', display: 'West Virginia'},
            { id: 'WI', display: 'Wisconsin'},
            { id: 'WY', display: 'Wyoming'}
        ];

        const operationRadOpts = [
            {id: 7, display: "<10 miles"},
            {id: 8, display: "10-20 miles"},
            {id: 9, display: "20-30 miles"},
            {id: 10, display: "30-40 miles"},
            {id: 11, display: "40-50 miles"},
            {id: 12, display: ">50 miles"},
        ];

        const dayTitles = ['Mon', 'Tues', 'Weds', 'Thurs', 'Fri', 'Sat', 'Sun'];
        const closedAr = ['Closed', 'Closed', 'Closed', 'Closed', 'Closed', 'Closed', 'Closed'];

        const timeOpts = [
            {id: " ", display: 'Set Hour'},
            {id: "0", display: '12:00 AM'},
            {id: "1", display: '1:00 AM'},
            {id: "2", display: '2:00 AM'},
            {id: "3", display: '3:00 AM'},
            {id: "4", display: '4:00 AM'},
            {id: "5", display: '5:00 AM'},
            {id: "6", display: '6:00 AM'},
            {id: "7", display: '7:00 AM'},
            {id: "8", display: '8:00 AM'},
            {id: "9", display: '9:00 AM'},
            {id: "10", display: '10:00 AM'},
            {id: "11", display: '11:00 AM'},
            {id: "12", display: '12:00 PM'},
            {id: "13", display: '1:00 PM'},
            {id: "14", display: '2:00 PM'},
            {id: "15", display: '3:00 PM'},
            {id: "16", display: '4:00 PM'},
            {id: "17", display: '5:00 PM'},
            {id: "18", display: '6:00 PM'},
            {id: "19", display: '7:00 PM'},
            {id: "20", display: '8:00 PM'},
            {id: "21", display: '9:00 PM'},
            {id: "22", display: '10:00 PM'},
            {id: "23", display: '11:00 PM'},
        ];

        const segmentOps = [
            {id: "commerical", display: "Commerical"},
            {id: "industrial", display: "Industrial"},
            {id: "residential", display: "Residential"},
        ];

        const servicesOpts = [
            {id: "audio_visual", display: "Audio/Visual"},
            {id: "high_voltage_install", display: "High Voltage Install"},
            {id: "low_voltage_install", display: "Low Voltage Install"},
            {id: "smart_home_install", display: "Smart Home Install"},
            {id: "wholehome_automation", display: "Wholehome Automation"},
        ];

        const refferalOpts = [
            {id: "customer", display: "Customer"},
            {id: "distributor", display: "Distributer"},
            {id: "email", display: "Email"},
            {id: "facebook", display: "Facebook"},
            {id: "instagram", display: "Instagram"},
            {id: "lighting_showroom", display: "Lighting Showroom"},
            {id: "print_ad", display: "Print Ad"},
            {id: "sales_rep", display: "Sales Rep"},
            {id: "tradeshow", display: "Tradeshow"},
            {id: "tv", display: "TV"},
            {id: "word_of_mouth", display: "Word of Mouth"},
        ];

        const ProfileSchema = Yup.object().shape({
            email: Yup.string().email('This value should be a valid email.').required('This value is required.'),
            first_name: Yup.string().required('This value is required.'),
            last_name: Yup.string().required('This value is required.'),
            name: Yup.string().required('This value is required.'),
            dba: Yup.string().required('This value is required.'),
            primary_jobtitle: Yup.string().required('This value is required.'),
            phone: Yup.string().required('This value is required.'),
            //country: Yup.string().required('This value is required.'),
           // address: Yup.string().required('This value is required.'),
           // city: Yup.string().required('This value is required.'),
           // state: Yup.string().required('This value is required.'),
           // postal: Yup.string().required('This value is required.').matches(/^[a-zA-Z0-9]*$/, 'This value should be alphanumeric characters only'),
            domain: Yup.string().required('This value is required.').url('This value should be a valid url.'),
            years_in_business: Yup.string().required('This value is required.'),
            coverage_range: Yup.string().required('This value is required.'),
            coverage_segments: Yup.string().required('This value is required.'),
            services_offered: Yup.string().required('This value is required.'),
            number_of_employees: Yup.string().required('This value is required.'),
            primary_distributor: Yup.string().required('This value is required.'),
        });

        let hearAboutNoon = "";
        if(this.state.cData.additional_information_hearAboutNoon != "" && this.state.cData.additional_information_hearAboutNoon != null) {
            hearAboutNoon = this.state.cData.additional_information_hearAboutNoon.split(',');
        }

        return(
            <div>
                {this.state.userLoaded === true && this.state.compLoaded === true && this.state.cDataLoaded === true ?
                    <div className='profile-data'>
                        <div className='short-desc'>
                            <h5>{this.state.companyD.name}</h5>
                            <p>{this.state.companyD.address}, {this.state.companyD.city}, {this.state.companyD.state}</p>
                            <a className='user--domain--link'
                               href={this.state.companyD.domain}>{this.state.companyD.domain}</a>
                            <br/>
                            <button className='edit-p-button' onClick={this.editProfile}>Edit Profile</button>
                            <h5 className='short-u-title'>Profile Image</h5>
                            {this.state.companyD.logo_path && <img className="logo-img" src={this.state.companyD.logo_path} />}
                            <br/>
                            <section>
                                <button className='edit-p-button' onClick={this.uploadProfileImage}>{this.state.uploadingProfile ? 'Uploading...' : 'Upload'}</button>
                                <input ref="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                            </section>

                        </div>
                        <div className='profile-details'>
                            <h3>Primary Contact Information</h3>
                            {this.state.editingProfile === true ?
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        domain: this.state.companyD.domain,
                                        electrician_certification: this.state.companyD.electrician_certification,
                                        reseller_certification: this.state.companyD.reseller_certification,
                                        coverage_range: this.state.companyD.coverage_range,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        number_of_employees: this.state.companyD.number_of_employees,
                                        years_in_business: this.state.companyD.years_in_business,
                                        primary_distributor: this.state.companyD.primary_distributor,
                                        secondary_distributor: this.state.companyD.secondary_distributor,
                                        dealer_finder: this.state.companyD.dealer_finder,
                                        experience_with_noon: this.state.companyD.experience_with_noon,
                                        file: "",

                                        mon_from: this.state.companyD.hoursofoperation.Mon.from,
                                        tues_from: this.state.companyD.hoursofoperation.Tues.from,
                                        weds_from: this.state.companyD.hoursofoperation.Weds.from,
                                        thurs_from: this.state.companyD.hoursofoperation.Thurs.from,
                                        fri_from: this.state.companyD.hoursofoperation.Fri.from,
                                        sat_from: this.state.companyD.hoursofoperation.Sat.from,
                                        sun_from: this.state.companyD.hoursofoperation.Sun.from,

                                        mon_to: this.state.companyD.hoursofoperation.Mon.to,
                                        tues_to: this.state.companyD.hoursofoperation.Tues.to,
                                        weds_to: this.state.companyD.hoursofoperation.Weds.to,
                                        thurs_to: this.state.companyD.hoursofoperation.Thurs.to,
                                        fri_to: this.state.companyD.hoursofoperation.Fri.to,
                                        sat_to: this.state.companyD.hoursofoperation.Sat.to,
                                        sun_to: this.state.companyD.hoursofoperation.Sun.to,

                                        mon_closed: this.state.companyD.hoursofoperation.Mon.closed,
                                        tues_closed: this.state.companyD.hoursofoperation.Tues.closed,
                                        weds_closed: this.state.companyD.hoursofoperation.Weds.closed,
                                        thurs_closed: this.state.companyD.hoursofoperation.Thurs.closed,
                                        fri_closed: this.state.companyD.hoursofoperation.Fri.closed,
                                        sat_closed: this.state.companyD.hoursofoperation.Sat.closed,
                                        sun_closed: this.state.companyD.hoursofoperation.Sun.closed,


                                        coverage_segments: this.state.companyD.coverage_segments.split(','),
                                        services_offered: this.state.companyD.services_offered.split(','),
                                        additional_information_hearAboutNoon:  hearAboutNoon,


                                    }}
                                    validationSchema={ProfileSchema}
                                    enableReinitialize={true}
                                    onSubmit={ async (values, actions) => {
                                        let coverage = parseInt(values.coverage_range, 10);
                                        let yearsInB = parseInt(values.years_in_business, 10);
                                        let numberOfE = parseInt(values.number_of_employees, 10);

                                        let hearedAbout = "";
                                        if (values.additional_information_hearAboutNoon != "" && values.additional_information_hearAboutNoon != []) {
                                            hearedAbout = values.additional_information_hearAboutNoon.join(",")
                                        }
                                        //console.log('about N', hearedAbout);
                                        let cSegments = "";
                                        if (values.coverage_segments != "" && values.coverage_segments != []) {
                                            cSegments = values.coverage_segments.join(",")
                                        }
                                        //console.log('s segs', cSegments);

                                        let servicesO = "";
                                        if (values.services_offered != "" && values.services_offered != []) {
                                            servicesO = values.services_offered.join(",")
                                        }
                                        //console.log('services', servicesO);

                                        let expWnoon = false;
                                        if(values.experience_with_noon === true) {
                                            expWnoon = true
                                        }

                                        let dealerF = false;
                                        if(values.dealer_finder === true) {
                                            dealerF = true
                                        }

                                        let data =  await this.handleVerifyAddress(this.state.address, this.state.city, this.state.state, this.state.postal, this.state.country,);

                                        return Promise.all([
                                                request.post('/api/user')
                                                    .send({
                                                        email: values.email,
                                                        first_name: values.first_name,
                                                        last_name: values.last_name,
                                                        additional_information_hearAboutNoon: hearedAbout,
                                                    }),
                                                request.post('/api/company')
                                                    .send({
                                                        name: values.name,
                                                        domain: values.domain,
                                                        phone: values.phone,
                                                        address_status: this.state.address_status,
                                                        country: this.state.country,
                                                        address: this.state.address,
                                                        city: this.state.city,
                                                        state: this.state.state,
                                                        postal: this.state.postal,
                                                        electrician_certification: values.electrician_certification,
                                                        reseller_certification: values.reseller_certification,
                                                        coverage_range: coverage,
                                                        dba: values.dba,
                                                        primary_jobtitle: values.primary_jobtitle,
                                                        years_in_business: yearsInB,
                                                        number_of_employees: numberOfE,
                                                        primary_distributor: values.primary_distributor,
                                                        secondary_distributor: values.secondary_distributor,
                                                        experience_with_noon: expWnoon,
                                                        dealer_finder: dealerF,
                                                        coverage_segments: cSegments,
                                                        services_offered: servicesO,
                                                        latitude: this.state.lat,
                                                        longitude: this.state.long,
                                                        geospatial: this.state.geo,

                                                        mon_from: values.mon_from,
                                                        tues_from: values.tues_from,
                                                        weds_from: values.weds_from,
                                                        thurs_from: values.thurs_from,
                                                        fri_from: values.fri_from,
                                                        sat_from: values.sat_from,
                                                        sun_from: values.sun_from,

                                                        mon_to: values.mon_to,
                                                        tues_to: values.tues_to,
                                                        weds_to: values.weds_to,
                                                        thurs_to: values.thurs_to,
                                                        fri_to: values.fri_to,
                                                        sat_to: values.sat_to,
                                                        sun_to: values.sun_to,

                                                        mon_closed: values.mon_closed,
                                                        tues_closed: values.tues_closed,
                                                        weds_closed: values.weds_closed,
                                                        thurs_closed: values.thurs_closed,
                                                        fri_closed: values.fri_closed,
                                                        sat_closed: values.sat_closed,
                                                        sun_closed: values.sun_closed,

                                                        number_of_stores: null,
                                                        business_coverage: null,
                                                        business_type: null,
                                                        speciality: null,
                                                        provide_staff_training: false,
                                                    })
                                            ])
                                                .then(data => {
                                                    //console.log('finished user call');
                                                    //console.log('not verified data', data);
                                                })
                                                .then(resp => {
                                                    this.setState({
                                                        updateFlag: true,
                                                        geo: null,
                                                        lat: null,
                                                        long: null,
                                                        address_status:'',
                                                    })
                                                })
                                                .catch(err => {
                                                    console.error(err);
                                                    this.setState({isError: true});
                                                });
                                    }}>

                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,
                                          isValid,
                                          isValidating,

                                      }) => (
                                        <Form className='my-f-form' onSubmit={e => {
                                            handleSubmit(e);
                                            if(isDisabled === true) {
                                                this.handleSubmitErr(e)
                                            }
                                        }}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.email}/>
                                            {errors.email && touched.email ?
                                                (<div className='f-field-errors'>{errors.email} </div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.first_name}
                                                        />
                                                        {errors.first_name && touched.first_name ? (
                                                            <div
                                                                className='f-field-errors'>{errors.first_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            value={values.last_name}
                                                        />
                                                        {errors.last_name && touched.last_name ?
                                                            (<div
                                                                className='f-field-errors'>{errors.last_name}</div>) : null
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.name}
                                            />
                                            {errors.name && touched.name ?
                                                (<div className='f-field-errors'>{errors.name}</div>) : null
                                            }

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.dba}
                                            />
                                            {errors.dba && touched.dba ?
                                                (<div className='f-field-errors'>{errors.dba}</div>) : null
                                            }

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.primary_jobtitle}
                                            />
                                            {errors.primary_jobtitle && touched.primary_jobtitle ?
                                                (<div className='f-field-errors'>{errors.primary_jobtitle}</div>) : null
                                            }

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.phone}
                                            />
                                            {errors.phone && touched.phone ?
                                                (<div className='f-field-errors'>{errors.phone}</div>) : null
                                            }

                                            <label className='form-f-label'>Country*</label>
                                            <select
                                                id='addressAutocomplete.country'
                                                name='country'
                                                className='single-choice-selector'
                                                value={this.state.country}
                                                onChange={e => this.handleCountryChange(e)}
                                                onBlur={this.handleAdrBlur('country')}
                                            >
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </select>
                                            {shouldShowError('country') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }

                                            <label className='form-f-label'>Address*</label>
                                            <input
                                                name='address'
                                                className={shouldShowError('address') ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                id='addressAutocomplete.street'
                                                placeholder='Address*'
                                                value={this.state.address}
                                                onChange={e => this.handleAdrChange(e)}
                                                onBlur={this.handleAdrBlur('address')}
                                            />
                                            {shouldShowError('address') ?
                                                (<div className='f-field-errors'>This value is required.</div>) : null
                                            }

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>City*</label>
                                                    <input
                                                        name='city'
                                                        className={shouldShowError('city') ? 'form-f-field with-error' : 'form-f-field'}
                                                        type='text'
                                                        id='addressAutocomplete.city'
                                                        placeholder='City*'
                                                        value={this.state.city}
                                                        onChange={e => this.handleCityChange(e)}
                                                        onBlur={this.handleAdrBlur('city')}
                                                    />
                                                    {shouldShowError('city') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>

                                                {this.state.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <select
                                                            name='state'
                                                            id='addressAutocomplete.state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={this.state.state}
                                                            onChange={e => this.handleStateChange(e)}
                                                            onBlur={this.handleAdrBlur('state')}
                                                        >
                                                            {caStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {shouldShowError('state') ?
                                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                                        }
                                                    </div>:
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <select
                                                            name='state'
                                                            id='addressAutocomplete.state'
                                                            className='state-selector'
                                                            placeholder='State'
                                                            value={this.state.state}
                                                            onChange={e => this.handleStateChange(e)}
                                                            onBlur={this.handleAdrBlur('state')}
                                                        >
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </select>
                                                        {shouldShowError('state') ?
                                                            (<div className='f-field-errors'>This value is required.</div>) : null
                                                        }
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <input
                                                        name='postal'
                                                        id='addressAutocomplete.postal'
                                                        className={shouldShowError('postal') ? 'form-f-field with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        value={this.state.postal}
                                                        onChange={e => this.handlePostalChange(e)}
                                                        onBlur={this.handleAdrBlur('postal')}
                                                    />
                                                    {shouldShowError('postal') ?
                                                        (<div className='f-field-errors'>This value is required.</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Website*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Electrician License Number</label>
                                            <input className='form-f-field'
                                                   type='text'
                                                   name='electrician_certification'
                                                   onChange={handleChange}
                                                   onBlur={handleBlur}
                                                   value={values.electrician_certification}
                                            />

                                            <label className='form-f-label'>Reseller Certification Number</label>
                                            <input className='form-f-field'
                                                   type='text'
                                                   name='reseller_certification'
                                                   onChange={handleChange}
                                                   onBlur={handleBlur}
                                                   value={values.reseller_certification}
                                            />

                                            <p className='disclaimer--copy'>Specify your reseller tax number and state
                                                above and upload a copy of your reseller certificate below.
                                                If you sell in multiple states, please upload them as a zip file. If no
                                                reseller certificate is provided, applicable sales tax will be charged
                                                on your purchases.</p>
                                            <br/>
                                            <section>
                                                <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Saving...' :  'Upload Certificate'}</a>
                                                <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                            </section>
                                            <br/>
                                            {this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null" ?
                                                <a className='edit-p-button' href={this.state.companyD.reseller_certification_path} target="_blank">View Certificate</a> : null
                                            }

                                            <label className='form-f-label'>Years in Business*</label>
                                            <Field
                                                name='years_in_business'
                                                component='input'
                                                className={errors.years_in_business && touched.years_in_business ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Years in Business*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.years_in_business}
                                            />
                                            {errors.years_in_business && touched.years_in_business ?
                                                (<div
                                                    className='f-field-errors'>{errors.years_in_business}</div>) : null
                                            }

                                            <h3 className='profile-data-section'>Coverage Information</h3>

                                            <label className='form-f-label'>Hours of Operation</label>

                                            <div className='op-hours-container'>
                                                <div className='time-opts-table'>
                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Mon</div>
                                                        </div>
                                                        {values.mon_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='mon_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`mon_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='mon_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`mon_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='mon_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`mon_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='mon_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`mon_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='mon_closed' checked={values.mon_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Tues</div>
                                                        </div>
                                                        {values.tues_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='tues_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`tues_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='tues_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`tues_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='tues_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`tues_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='tues_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`tues_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='tues_closed' checked={values.tues_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Weds</div>
                                                        </div>
                                                        {values.weds_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='weds_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`weds_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='weds_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`weds_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='weds_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`weds_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='weds_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`weds_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='weds_closed' checked={values.weds_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Thurs</div>
                                                        </div>
                                                        {values.thurs_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='thurs_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`thurs_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='thurs_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`thurs_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='thurs_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`thurs_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='thurs_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`thurs_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='thurs_closed' checked={values.thurs_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>

                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Fri</div>
                                                        </div>
                                                        {values.fri_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='fri_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`fri_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='fri_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`fri_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='fri_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`fri_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='fri_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`fri_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='fri_closed' checked={values.fri_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Sat</div>
                                                        </div>
                                                        {values.sat_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='sat_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sat_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='sat_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sat_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='sat_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sat_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='sat_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sat_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='sat_closed' checked={values.sat_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Sun</div>
                                                        </div>
                                                        {values.sun_closed === true ?
                                                            <div className='time-selects-holder'>
                                                                <Field name='sun_from' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sun_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='sun_to' component='select'
                                                                       className='open-time-selector not-active'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sun_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div> :
                                                            <div className='time-selects-holder'>
                                                                <Field name='sun_from' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sun_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='sun_to' component='select'
                                                                       className='open-time-selector'>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sun_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        }
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox'
                                                                   name='sun_closed' checked={values.sun_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>


                                            <label className='form-f-label'>Coverage Area*</label>
                                            <Field name='coverage_range' component='select'
                                                   className='single-choice-selector'>
                                                {operationRadOpts.map(option => (
                                                    <option key={`coverage_range-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>
                                            {errors.coverage_range && touched.coverage_range ?
                                                (<div className='f-field-errors'>{errors.coverage_range}</div>) : null
                                            }

                                            <label className='form-f-label'>Coverage Segments*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <FieldArray
                                                name='coverage_segments'
                                                render={arrayHelpers => (
                                                    <div>
                                                        {segmentOps.map(option => (
                                                            <div key={option.id}>
                                                                <input
                                                                    name='coverage_segments'
                                                                    type='checkbox'
                                                                    value={option.id}
                                                                    checked={values.coverage_segments.includes(option.id)}
                                                                    onChange={event => {
                                                                        if (event.target.checked) {
                                                                            arrayHelpers.push(option.id);
                                                                        }
                                                                        else {
                                                                            const idx = values.coverage_segments.indexOf(option.id);
                                                                            arrayHelpers.remove(idx);
                                                                        }
                                                                    }}
                                                                /> {option.display}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                            {errors.coverage_segments && touched.coverage_segments ?
                                                (<div
                                                    className='f-field-errors'>{errors.coverage_segments}</div> ) : null
                                            }

                                            <label className='form-f-label'>Services Offered*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <FieldArray
                                                name='services_offered'
                                                render={arrayHelpers => (
                                                    <div>
                                                        {servicesOpts.map(option => (
                                                            <div key={option.id}>
                                                                <input
                                                                    name='services_offered'
                                                                    type='checkbox'
                                                                    value={option.id}
                                                                    checked={values.services_offered.includes(option.id)}
                                                                    onChange={event => {
                                                                        if (event.target.checked) {
                                                                            arrayHelpers.push(option.id);
                                                                        }
                                                                        else {
                                                                            const idx = values.services_offered.indexOf(option.id);
                                                                            arrayHelpers.remove(idx);
                                                                        }
                                                                    }}
                                                                /> {option.display}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />
                                            {errors.services_offered && touched.services_offered ?
                                                (<div className='f-field-errors'>{errors.services_offered}</div>) : null
                                            }

                                            <label className='form-f-label'>Number of Employees*</label>
                                            <Field
                                                name='number_of_employees'
                                                component='input'
                                                className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Employees*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.number_of_employees}
                                            />
                                            {errors.number_of_employees && touched.number_of_employees ?
                                                (<div
                                                    className='f-field-errors'>{errors.number_of_employees}</div>) : null
                                            }

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='dealer_finder'
                                                    checked={values.dealer_finder}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Add to NOON finder?</p>
                                            </div>

                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'>Primary Distributor*</label>
                                            <Field
                                                name='primary_distributor'
                                                component='input'
                                                className={errors.primary_distributor && touched.primary_distributor ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Primary Distributor*'
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                value={values.primary_distributor}
                                            />
                                            {errors.primary_distributor && touched.primary_distributor ?
                                                (<div
                                                    className='f-field-errors'>{errors.primary_distributor}</div>) : null
                                            }

                                            <label className='form-f-label'>Secondary Distributor</label>
                                            <input className='form-f-field'
                                                   type='text'
                                                   name='secondary_distributor'
                                                   onChange={handleChange}
                                                   onBlur={handleBlur}
                                                   value={values.secondary_distributor}
                                            />

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                            <FieldArray
                                                name='additional_information_hearAboutNoon'
                                                render={arrayHelpers => (
                                                    <div>
                                                        {refferalOpts.map(option => (
                                                            <div key={option.id}>
                                                                <input
                                                                    name='additional_information_hearAboutNoon'
                                                                    type='checkbox'
                                                                    value={option.id}
                                                                    checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                    onChange={event => {
                                                                        if (event.target.checked) {
                                                                            arrayHelpers.push(option.id);
                                                                        }
                                                                        else {
                                                                            const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                            arrayHelpers.remove(idx);
                                                                        }
                                                                    }}
                                                                /> {option.display}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            />

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='experience_with_noon'
                                                    checked={values.experience_with_noon}
                                                    onChange={handleChange}
                                                />
                                                <p className='toggle-in-label'>Do you have Experience installing
                                                    NOON?</p>
                                            </div>

                                            <div className='error-box-cont'>
                                                {this.state.isError === true ?
                                                    <p className='submission-error-text'>Ooops something went wrong!
                                                        Please try again later</p> :
                                                    null
                                                }
                                            </div>

                                            { isDisabled === true ?
                                                <button type='submit' className='form-f-button' onClick={e => this.handleSubmitErr(e)}> Save Profile</button> :
                                                <button type='submit' className='form-f-button'> Save Profile</button>
                                            }

                                            {dirty ?
                                                <a className='form-cancel-button' type="cancel"
                                                        disabled={isSubmitting}
                                                        onClick={handleReset}>
                                                    Reset Form
                                                </a> :
                                                <a className='form-cancel-button' type="cancel"
                                                        disabled={isSubmitting}
                                                        onClick={this.editProfile}>
                                                    Cancel
                                                </a>
                                            }
                                        </Form>
                                    )}

                                </Formik> :
                                <Formik
                                    initialValues={{
                                        email: this.state.userD.email,
                                        first_name: this.state.cData.first_name,
                                        last_name: this.state.cData.last_name,
                                        name: this.state.companyD.name,
                                        phone: this.state.companyD.phone,
                                        address: this.state.companyD.address,
                                        country: this.state.companyD.country,
                                        city: this.state.companyD.city,
                                        state: this.state.companyD.state,
                                        postal: this.state.companyD.postal,
                                        domain: this.state.companyD.domain,
                                        electrician_certification: this.state.companyD.electrician_certification,
                                        reseller_certification: this.state.companyD.reseller_certification,
                                        coverage_range: this.state.companyD.coverage_range,
                                        dba: this.state.companyD.dba,
                                        primary_jobtitle: this.state.companyD.primary_jobtitle,
                                        number_of_employees: this.state.companyD.number_of_employees,
                                        years_in_business: this.state.companyD.years_in_business,
                                        primary_distributor: this.state.companyD.primary_distributor,
                                        secondary_distributor: this.state.companyD.secondary_distributor,
                                        dealer_finder: this.state.companyD.dealer_finder,
                                        experience_with_noon: this.state.companyD.experience_with_noon,
                                        file: "",

                                        mon_from: this.state.companyD.hoursofoperation.Mon.from,
                                        tues_from: this.state.companyD.hoursofoperation.Tues.from,
                                        weds_from: this.state.companyD.hoursofoperation.Weds.from,
                                        thurs_from: this.state.companyD.hoursofoperation.Thurs.from,
                                        fri_from: this.state.companyD.hoursofoperation.Fri.from,
                                        sat_from: this.state.companyD.hoursofoperation.Sat.from,
                                        sun_from: this.state.companyD.hoursofoperation.Sun.from,

                                        mon_to: this.state.companyD.hoursofoperation.Mon.to,
                                        tues_to: this.state.companyD.hoursofoperation.Tues.to,
                                        weds_to: this.state.companyD.hoursofoperation.Weds.to,
                                        thurs_to: this.state.companyD.hoursofoperation.Thurs.to,
                                        fri_to: this.state.companyD.hoursofoperation.Fri.to,
                                        sat_to: this.state.companyD.hoursofoperation.Sat.to,
                                        sun_to: this.state.companyD.hoursofoperation.Sun.to,

                                        mon_closed: this.state.companyD.hoursofoperation.Mon.closed,
                                        tues_closed: this.state.companyD.hoursofoperation.Tues.closed,
                                        weds_closed: this.state.companyD.hoursofoperation.Weds.closed,
                                        thurs_closed: this.state.companyD.hoursofoperation.Thurs.closed,
                                        fri_closed: this.state.companyD.hoursofoperation.Fri.closed,
                                        sat_closed: this.state.companyD.hoursofoperation.Sat.closed,
                                        sun_closed: this.state.companyD.hoursofoperation.Sun.closed,


                                        coverage_segments: this.state.companyD.coverage_segments.split(','),
                                        services_offered: this.state.companyD.services_offered.split(','),
                                        additional_information_hearAboutNoon:  hearAboutNoon,


                                    }}
                                    validationSchema={ProfileSchema}
                                    enableReinitialize={true}
                                    onSubmit={(values, actions) => {
                                        return Promise.all([
                                            request.post('/api/user')
                                                .send({
                                                    email: values.email,
                                                }),
                                            request.post('/api/company')
                                                .send({
                                                    name: values.name,
                                                })
                                        ])
                                            .then(data => {
                                                console.log('finished user call');
                                                console.log(data);
                                            })
                                            .then(resp => {
                                                this.setState({updateFlag: true})
                                            })
                                    }}>

                                    {({
                                          values,
                                          errors,
                                          touched,
                                          handleChange,
                                          handleBlur,
                                          handleSubmit,
                                          isSubmitting,
                                          setFieldValue,
                                          handleReset,
                                          dirty,

                                      }) => (
                                          <Form className='my-f-form' onSubmit={handleSubmit}>
                                            <label className='form-f-label'>Email*</label>
                                            <Field
                                                name='email'
                                                className={errors.email && touched.email ? 'form-f-field with-error' : 'form-f-field'}
                                                component='input'
                                                type='text'
                                                placeholder='Email*'
                                                disabled={true}
                                                value={values.email}/>

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='form-f-label'>First Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='first_name'
                                                            component='input'
                                                            className={errors.first_name && touched.first_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='First Name*'
                                                            disabled={true}
                                                            value={values.first_name}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Last Name*</label>
                                                    <div className='flex-with-error-holder'>
                                                        <Field
                                                            name='last_name'
                                                            component='input'
                                                            className={errors.last_name && touched.last_name ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                            type='text'
                                                            placeholder='Last Name*'
                                                            disabled={true}
                                                            value={values.last_name}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            <h3 className='profile-data-section'>Business Information</h3>

                                            <label className='form-f-label'>Company Name*</label>
                                            <Field
                                                name='name'
                                                component='input'
                                                className={errors.name && touched.name ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Company Name*'
                                                disabled={true}
                                                value={values.name}
                                            />

                                            <label className='form-f-label'>Doing Business As (DBA)*</label>
                                            <Field
                                                name='dba'
                                                component='input'
                                                className={errors.dba && touched.dba ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Doing Business As*'
                                                disabled={true}
                                                value={values.dba}
                                            />

                                            <label className='form-f-label'>Job Title*</label>
                                            <Field
                                                name='primary_jobtitle'
                                                component='input'
                                                className={errors.primary_jobtitle && touched.primary_jobtitle ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Job Title*'
                                                disabled={true}
                                                value={values.primary_jobtitle}
                                            />

                                            <label className='form-f-label'>Primary Phone*</label>
                                            <Field
                                                name='phone'
                                                component='input'
                                                className={errors.phone && touched.phone ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='(___)___-____'
                                                disabled={true}
                                                value={values.phone}
                                            />

                                            <label className='form-f-label'>Country*</label>
                                            <Field name='country' component='select'  disabled={true}
                                                   className='single-choice-selector'>
                                                {countryOpts.map(option => (
                                                    <option key={`country-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <label className='form-f-label'>Address*</label>
                                            <Field
                                                name='address'
                                                component='input'
                                                className={errors.address && touched.address ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Address*'
                                                disabled={true}
                                                value={values.address}
                                            />

                                            <div className='flex--fields--holder'>
                                                <div className='flex-field-container'>
                                                    <label className='flex-form-label'>City*</label>
                                                    <Field
                                                        name='city'
                                                        component='input'
                                                        className={errors.city && touched.city ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='City*'
                                                        disabled={true}
                                                        value={values.city}
                                                    />
                                                </div>

                                                {values.country === 'CA' ?
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select'
                                                               className='state-selector' placeholder='State'>
                                                            {caStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        {errors.state && touched.state ?
                                                            (<div className='f-field-errors'>{errors.state}</div>) : null
                                                        }
                                                    </div> :
                                                    <div className='flex-field-container'>
                                                        <label className='flex-form-label'>State*</label>
                                                        <Field name='state' component='select'
                                                               className='state-selector' placeholder='State'>
                                                            {usStateOpts.map(option => (
                                                                <option key={`state-${option.id}`}
                                                                        value={option.id}>
                                                                    {option.display}
                                                                </option>
                                                            ))}
                                                        </Field>
                                                        {errors.state && touched.state ?
                                                            (<div className='f-field-errors'>{errors.state}</div>) : null
                                                        }
                                                    </div>
                                                }

                                                <div className='flex-field-container last'>
                                                    <label className='form-f-label'>Postal Code*</label>
                                                    <Field
                                                        name='postal'
                                                        component='input'
                                                        className={errors.postal && touched.postal ? 'form-f-field flex-with-error' : 'form-f-field'}
                                                        type='text'
                                                        placeholder='Postal Code*'
                                                        disabled={true}
                                                        value={values.postal}
                                                    />
                                                    {errors.postal && touched.postal ?
                                                        (<div className='f-field-errors'>{errors.postal}</div>) : null
                                                    }
                                                </div>
                                            </div>

                                            <label className='form-f-label'>Website*</label>
                                            <Field
                                                name='domain'
                                                component='input'
                                                className={errors.domain && touched.domain ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                disabled={true}
                                                placeholder='Website*'
                                                value={values.domain}
                                            />
                                            {errors.domain && touched.domain ?
                                                (<div className='f-field-errors'>{errors.domain}</div>) : null
                                            }

                                            <label className='form-f-label'>Electrician License Number</label>
                                              <Field
                                                  component='input'
                                                  className='form-f-field'
                                                  type='text'
                                                  name='electrician_certification'
                                                  disabled={true}
                                                  value={values.electrician_certification}
                                              />

                                            <label className='form-f-label'>Reseller Certification Number</label>
                                              <Field
                                                  component='input'
                                                  className='form-f-field'
                                                  type='text'
                                                  name='reseller_certification'
                                                  disabled={true}
                                                  value={values.reseller_certification}
                                              />

                                            <p className='disclaimer--copy'>Specify your reseller tax number and state
                                                above and upload a copy of your reseller certificate below.
                                                If you sell in multiple states, please upload them as a zip file. If no
                                                reseller certificate is provided, applicable sales tax will be charged
                                                on your purchases.</p>
                                              <br/>
                                              <section>
                                                  <a className='edit-p-button' onClick={this.uploadResellerCertificate}>{this.state.uploadingCertificate ? 'Saving...' :  'Upload Certificate'}</a>
                                                  <input name="onUploadUserFile" onChange={this.onUploadUserFile} style={{display: 'none'}} type="file" />
                                              </section>
                                              <br/>
                                              {this.state.companyD.reseller_certification_path !== undefined && this.state.companyD.reseller_certification_path !== "null" ?
                                                  <a className='edit-p-button' href={this.state.companyD.reseller_certification_path} target="_blank">View Certificate</a> : null
                                              }

                                            <label className='form-f-label'>Years in Business*</label>
                                            <Field
                                                name='years_in_business'
                                                component='input'
                                                className={errors.years_in_business && touched.years_in_business ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Years in Business*'
                                                value={values.years_in_business}
                                                disabled={true}
                                            />

                                            <h3 className='profile-data-section'>Coverage Information</h3>

                                            <label className='form-f-label'>Hours of Operation</label>

                                            <div className='op-hours-container'>
                                                <div className='time-opts-table'>
                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Mon</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='mon_from' component='select'
                                                                       className='open-time-selector '
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`mon_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='mon_to' component='select'
                                                                       className='open-time-selector '
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`mon_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='mon_closed' checked={values.mon_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Tues</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='tues_from' component='select'
                                                                       className='open-time-selector'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`tues_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='tues_to' component='select'
                                                                       className='open-time-selector'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`tues_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='tues_closed' checked={values.tues_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Weds</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='weds_from' component='select'
                                                                       className='open-time-selector '
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`weds_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='weds_to' component='select'
                                                                       className='open-time-selector '
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`weds_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='weds_closed' checked={values.weds_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Thurs</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='thurs_from' component='select'
                                                                       className='open-time-selector'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`thurs_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='thurs_to' component='select'
                                                                       className='open-time-selector'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`thurs_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='thurs_closed' checked={values.thurs_closed} >
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>

                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Fri</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='fri_from' component='select'
                                                                       className='open-time-selector'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`fri_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='fri_to' component='select'
                                                                       className='open-time-selector'
                                                                       disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`fri_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='fri_closed' checked={values.fri_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Sat</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='sat_from' component='select'
                                                                       className='open-time-selector ' disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sat_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='sat_to' component='select'
                                                                       className='open-time-selector ' disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sat_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='sat_closed' checked={values.sat_closed}>
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                    <div className='time-opt-row'>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Sun</div>
                                                        </div>
                                                            <div className='time-selects-holder'>
                                                                <Field name='sun_from' component='select'
                                                                       className='open-time-selector' disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sun_from-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                                <Field name='sun_to' component='select'
                                                                       className='open-time-selector ' disabled={true}>
                                                                    {timeOpts.map(option => (
                                                                        <option key={`sun_to-${option.id}`}
                                                                                value={option.id}>
                                                                            {option.display}
                                                                        </option>
                                                                    ))}
                                                                </Field>
                                                            </div>
                                                        <div className='check-boxes-holder'>
                                                            <Field className='closed--checkbox' type='checkbox' disabled={true}
                                                                   name='sun_closed' checked={values.sun_closed} >
                                                            </Field>
                                                        </div>
                                                        <div className='titles-container'>
                                                            <div className='text-title'>Closed</div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>


                                            <label className='form-f-label'>Coverage Area*</label>
                                            <Field name='coverage_range' component='select' disabled={true}
                                                   className='single-choice-selector'>
                                                {operationRadOpts.map(option => (
                                                    <option key={`coverage_range-${option.id}`} value={option.id}>
                                                        {option.display}
                                                    </option>
                                                ))}
                                            </Field>

                                            <label className='form-f-label'>Coverage Segments*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                              <div className='box--outline-comp'>
                                                  <div className='checkbox-group-content'>
                                                      <FieldArray
                                                          name='coverage_segments'
                                                          render={arrayHelpers => (
                                                              <div>
                                                                  {segmentOps.map(option => (
                                                                      <div key={option.id}>
                                                                          <input
                                                                              disabled={true}
                                                                              name='coverage_segments'
                                                                              type='checkbox'
                                                                              value={option.id}
                                                                              checked={values.coverage_segments.includes(option.id)}
                                                                              onChange={event => {
                                                                                  if (event.target.checked) {
                                                                                      arrayHelpers.push(option.id);
                                                                                  }
                                                                                  else {
                                                                                      const idx = values.coverage_segments.indexOf(option.id);
                                                                                      arrayHelpers.remove(idx);
                                                                                  }
                                                                              }}
                                                                          /> {option.display}
                                                                      </div>
                                                                  ))}
                                                              </div>
                                                          )}
                                                      />
                                                  </div>
                                              </div>

                                            <label className='form-f-label'>Services Offered*</label>
                                            <label className='second-f-label'>Select Options:</label>
                                              <div className='box--outline-comp'>
                                                  <div className='checkbox-group-content'>
                                                      <FieldArray
                                                          name='services_offered'
                                                          render={arrayHelpers => (
                                                              <div>
                                                                  {servicesOpts.map(option => (
                                                                      <div key={option.id}>
                                                                          <input
                                                                              disabled={true}
                                                                              name='services_offered'
                                                                              type='checkbox'
                                                                              value={option.id}
                                                                              checked={values.services_offered.includes(option.id)}
                                                                              onChange={event => {
                                                                                  if (event.target.checked) {
                                                                                      arrayHelpers.push(option.id);
                                                                                  }
                                                                                  else {
                                                                                      const idx = values.services_offered.indexOf(option.id);
                                                                                      arrayHelpers.remove(idx);
                                                                                  }
                                                                              }}
                                                                          /> {option.display}
                                                                      </div>
                                                                  ))}
                                                              </div>
                                                          )}
                                                      />
                                                  </div>
                                              </div>

                                            <label className='form-f-label'>Number of Employees*</label>
                                            <Field
                                                name='number_of_employees'
                                                component='input'
                                                className={errors.number_of_employees && touched.number_of_employees ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Number of Employees*'
                                                disabled={true}
                                                value={values.number_of_employees}
                                            />

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='dealer_finder'
                                                    checked={values.dealer_finder}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Add to NOON finder?</p>
                                            </div>

                                            <h3 className='profile-data-section'>Additional Information</h3>

                                            <label className='form-f-label'>Primary Distributor*</label>
                                            <Field
                                                name='primary_distributor'
                                                component='input'
                                                className={errors.primary_distributor && touched.primary_distributor ? 'form-f-field with-error' : 'form-f-field'}
                                                type='text'
                                                placeholder='Primary Distributor*'
                                                disabled={true}
                                                value={values.primary_distributor}
                                            />

                                            <label className='form-f-label'>Secondary Distributor</label>
                                            <Field
                                                component='input'
                                                className='form-f-field'
                                                type='text'
                                                name='secondary_distributor'
                                                disabled={true}
                                                value={values.secondary_distributor}
                                            />

                                            <label className='form-f-label'>How you heard about NOON?</label>
                                            <label className='second-f-label'>Select Options:</label>
                                              <div className='box--outline-comp'>
                                                  <div className='checkbox-group-content'>
                                                      <FieldArray
                                                          name='additional_information_hearAboutNoon'
                                                          render={arrayHelpers => (
                                                              <div>
                                                                  {refferalOpts.map(option => (
                                                                      <div key={option.id}>
                                                                          <input
                                                                              disabled={true}
                                                                              name='additional_information_hearAboutNoon'
                                                                              type='checkbox'
                                                                              value={option.id}
                                                                              checked={values.additional_information_hearAboutNoon.includes(option.id)}
                                                                              onChange={event => {
                                                                                  if (event.target.checked) {
                                                                                      arrayHelpers.push(option.id);
                                                                                  }
                                                                                  else {
                                                                                      const idx = values.additional_information_hearAboutNoon.indexOf(option.id);
                                                                                      arrayHelpers.remove(idx);
                                                                                  }
                                                                              }}
                                                                          /> {option.display}
                                                                      </div>
                                                                  ))}
                                                              </div>
                                                          )}
                                                      />
                                                  </div>
                                              </div>

                                            <div className='toggle-switch-gr'>
                                                <input
                                                    type='checkbox'
                                                    className='toggle--input--btn'
                                                    name='experience_with_noon'
                                                    checked={values.experience_with_noon}
                                                    readOnly={true}
                                                />
                                                <p className='toggle-in-label'>Do you have Experience installing
                                                    NOON?</p>
                                            </div>

                                        </Form>
                                    )}
                                </Formik>
                            }
                        </div>
                    </div>:
                    <Loader/>
                }
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/routes/UserProfile/ResellerProfile.js